export { default } from './HolesPanel';
